const initSearch = (toggle, onOpen) => {
    toggle.setAttribute('aria-expanded', 'false');

    const body = document.querySelector('.js-body');
    const search = document.querySelector('.js-search');

    if (!search) { return { close: () => {} }; }

    const input = search.querySelector('.js-search-input');
    const submit = search.querySelector('.js-search-submit');
    const form = search.querySelector('.js-search-form');
    const searchContent = search.querySelector('.js-search-content');
    const suggestions = search.querySelector('.js-search-suggestions');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'search-open';

    let searchOpen = false;
    let suggestionsFadeHandler = null;
    let activeFetch = null;

    const clearResults = () => {
        const existing = searchContent.querySelector('.js-search-results');

        if (existing) {
            existing.remove();
        }
    };

    const cancelSuggestionsFade = () => {
        if (!suggestionsFadeHandler) { return; }

        suggestions.removeEventListener('transitionend', suggestionsFadeHandler);
        suggestionsFadeHandler = null;
    };

    const reset = () => {
        if (suggestions) {
            cancelSuggestionsFade();
        }

        clearResults();

        if (input) {
            input.value = '';
        }

        if (suggestions) {
            suggestions.classList.remove('is-fading');

            if (!searchContent.contains(suggestions)) {
                searchContent.appendChild(suggestions);
            }
        }
    };

    const close = () => {
        searchOpen = false;
        toggle.setAttribute('aria-expanded', 'false');
        body.classList.remove(stopScrollingClass, isActiveClass);

        if (input) {
            input.blur();
        }

        if (submit) {
            submit.setAttribute('tabindex', '-1');
        }

        setTimeout(reset, 300);
    };

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchOpen) {
            close();
        }
    });

    document.addEventListener('click', (event) => {
        if (event.target === toggle) {
            event.preventDefault();
            searchOpen = !searchOpen;

            if (searchOpen) {
                if (onOpen) {
                    onOpen();
                }

                toggle.setAttribute('aria-expanded', 'true');
                body.classList.add(stopScrollingClass, isActiveClass);

                if (input) {
                    input.focus();
                }

                if (submit) {
                    submit.removeAttribute('tabindex');
                }
            } else {
                close();
            }
        }
    });

    if (suggestions) {
        suggestions.addEventListener('click', (event) => {
            const link = event.target.closest('a');
            if (!link) { return; }

            event.preventDefault();

            const term = new URL(link.href).searchParams.get('s');

            if (term && input) {
                input.value = term;
                form.requestSubmit();
            }
        });
    }

    if (form) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            let query = '';

            if (input) {
                query = input.value.trim();
            }

            clearResults();

            if (!query) { return; }

            const url = new URL(form.action);
            url.searchParams.set('s', query);

            if (activeFetch) {
                activeFetch.abort();
            }

            const controller = new AbortController();
            activeFetch = controller;

            search.classList.add('is-loading');

            fetch(url, { signal: controller.signal })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }

                    return response.text();
                })
                .then((html) => {
                    if (controller.signal.aborted) { return; }

                    search.classList.remove('is-loading');

                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const results = doc.querySelector('.js-search-results');

                    const showResults = () => {
                        if (results) {
                            clearResults();
                            searchContent.appendChild(results);
                            results.getBoundingClientRect();
                            results.classList.add('is-visible');
                        }
                    };

                    if (suggestions && searchContent.contains(suggestions)) {
                        cancelSuggestionsFade();

                        suggestionsFadeHandler = () => {
                            suggestionsFadeHandler = null;
                            suggestions.remove();
                            showResults();
                        };

                        suggestions.addEventListener('transitionend', suggestionsFadeHandler);
                        suggestions.classList.add('is-fading');
                    } else {
                        showResults();
                    }
                })
                .catch((error) => {
                    if (error.name !== 'AbortError') {
                        search.classList.remove('is-loading');
                        console.error('Search failed:', error);
                    }
                });
        });
    }

    return { close };
};

export { initSearch as default };
